import React from 'react';
import ReactPlayer from 'react-player';
import { Document, Page } from './LazyPDF';
import { useState, useEffect, useRef } from 'react';
import { AiOutlineZoomIn,AiOutlineZoomOut,AiOutlineDoubleLeft,AiOutlineDoubleRight } from "react-icons/ai";

export function PDFViewer({ url }) {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const [numPages, setNumPages] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [scale, setScale] = useState(1.0);
  
    useEffect(() => {
      const handleResize = () => {
        if (containerRef.current) {
          setContainerWidth(containerRef.current.offsetWidth);
        }
      };
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    const onDocumentLoadSuccess = ({ numPages }) => {
      setNumPages(numPages);
      setPageNumber(1); // Reset to first page on load
    };
  
    const goToPrevPage = () => setPageNumber((prev) => Math.max(prev - 1, 1));
    const goToNextPage = () => setPageNumber((prev) => Math.min(prev + 1, numPages));
    const zoomIn = () => setScale((prev) => Math.min(prev + 0.2, 3));
    const zoomOut = () => setScale((prev) => Math.max(prev - 0.2, 0.5));
  
    return (
      <div className="w-full flex flex-col items-center">
        <div className="flex space-x-4 mb-2 text-sm text-gray-800">
          <button onClick={goToPrevPage} disabled={pageNumber === 1} className="px-3 py-1 border rounded">
          <AiOutlineDoubleLeft />
          </button>
          <span className='pt-1'>
            Page {pageNumber} of {numPages}
          </span>
          <button onClick={goToNextPage} disabled={pageNumber === numPages} className="px-3 py-1 border rounded">
          <AiOutlineDoubleRight />
          </button>
          <button onClick={zoomOut} className="px-3 text-gray-800 py-1 border rounded">
          <AiOutlineZoomOut />
          </button>
          <button onClick={zoomIn} className="px-3  text-gray-800 py-1 border rounded">
          <AiOutlineZoomIn />
          </button>
        </div>
  
        <div ref={containerRef} className="flex-1 overflow-auto w-full border rounded-lg">
          <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
            <Page
              pageNumber={pageNumber}
              width={containerWidth * scale}
              renderAnnotationLayer={false}
              renderTextLayer={false}
            />
          </Document>
        </div>
      </div>
    );
  }

const ContentViewer = ({ url, filename }) => {
  const extension = filename.split('.').pop().toLowerCase();

  const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension);
  const isVideo = ['mp4', 'webm', 'mov'].includes(extension);
  const isAudio = ['mp3', 'wav', 'ogg'].includes(extension);
  const isPDF = extension === 'pdf';

  return (
    <div className="w-full mx-auto my-1 p-1 bg-white shadow-lg rounded-lg">
      {isImage && (
        <div className="flex justify-center items-center w-full max-h-[75vh] overflow-auto">
          <img
            src={url}
            alt="Preview"
            className="max-h-[75vh] w-full object-contain rounded-lg"
          />
        </div>
      )}

      {isVideo && (
        <div className="flex justify-center items-center w-full max-h-[75vh] overflow-auto">
          <video
            controls
            controlsList="nodownload"
            className="max-h-[75vh] w-full object-contain rounded-lg"
          >
            <source src={url} />
            Your browser does not support the video tag.
          </video>
        </div>
      )}

      {isAudio && (
        <audio controls className="w-full mt-2">
          <source src={url} />
          Your browser does not support the audio element.
        </audio>
      )}

      {isPDF && (
        <PDFViewer url={url}/>
       
      )}

      {!isImage && !isVideo && !isAudio && !isPDF && (
        <div className="text-center text-gray-500">
          Unsupported content type
        </div>
      )}
    </div>
  );
};

export default ContentViewer;
